import { SectionHeader } from '~analytics-components/section-header';
import type { ResolvedPageFilter } from '~containers/analytics/overview-page/use-page-filter';
import { KpiCardFromSpec } from '../kpis/kpi-card-from-spec';
import type { KpiCardSpec } from '../kpis/card-spec';
import { ENGAGEMENT_BREAKDOWN_CARDS, USAGE_ADOPTION_CARDS } from './cards';
import style from './style.module.scss';

export const EngagementSection = ({
    filter,
}: {
    filter: ResolvedPageFilter;
}) => {
    const renderCard = (spec: KpiCardSpec, index: number) => (
        <KpiCardFromSpec
            key={`${spec.source}-${spec.form}-${index}`}
            spec={spec}
            pageRange={filter.range}
            pageRegion={filter.provinces}
            compareEnabled={filter.compare}
            waveKey={filter.waveKey}
        />
    );

    return (
        <div className={style.dashboard}>
            <section className={style.section}>
                <SectionHeader title="Engagement breakdown" />
                <div className={style.dashboard_grid}>
                    {ENGAGEMENT_BREAKDOWN_CARDS.map(renderCard)}
                </div>
            </section>
            <section className={style.section}>
                <SectionHeader title="Usage & adoption" />
                <div className={style.dashboard_grid}>
                    {USAGE_ADOPTION_CARDS.map(renderCard)}
                </div>
            </section>
        </div>
    );
};
